import Alert from './Alert';

/**
 * Uso:
 *   return <AlertException error={error} fallback="Não foi possível carregar a lista." />
 * - Mostra mensagem amigável vinda do interceptor (error.userMessage)
 * - Se não houver, usa o fallback
 */
export default function AlertException({ error, fallback = 'Ocorreu um erro. Tente novamente.' }) {
  const msg = error?.userMessage || fallback;
  return <Alert variant="danger">{msg}</Alert>;
}